<template>
<div id="sale_investment">
    <link href="/static/css/general/style2.css" rel="stylesheet">
    <div class="header">
        <div class="header-top">
            <div class="wrapper clearfix">
                <div class="col-xs-120">
                    <div class="logo">
                        <router-link to="/"><img src="/static/img/general/logo-franchise.png"></router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="franchise_blocks">
            <div class="franchise_block franchise_block_two" style="border: 2px solid #cecece;">
                <router-link to="/sale-franchise/">
                    <p>Информация <br> по франчайзингу</p>
                </router-link>
            </div>
            <div class="franchise_block" style="border: 2px solid #4a80c6;">
                <router-link to="/sale-investment/">
                    <p>Инвестировать <br> в открытие <br> <span>без участия в управлении</span></p>
                </router-link>
            </div>
            <div class="franchise_block franchise_block_two">
                <router-link to="/saas-rus/">
                    <p>Создать свой агрегатор<br><br> <span>и не зависеть от франшизы</span></p>
                </router-link>
            </div>
        </div>
        <div class="header-bottom-investment">
            <div class="wrapper clearfix">
                <div class="col-xs-120">
                    <p class="header-bottom-inverstment-p">Вы хотите инвестировать в открытие агрегатора В-АВТОСЕРВИС / EASY-REPAIR <br> в каком-либо городе или стране, но не хотите участвовать <br> в оперативном управлении?</p>
                    <div class="business">Все управление мы возьмем на себя!</div>
                </div>
            </div>
        </div>
    </div>
    <div class="header-bottom-investment-blog">
        <div class="clearfix"></div>
        <h2 class="header-bottom-h2">Как это происходит?</h2>
        <div class="col-md-25 col-sm-60 no-padding">
            <div class="item item-1">Вместе с Вами мы определяем город или страну</div>
        </div>
        <div class="col-md-20 col-sm-60 no-padding">
            <div class=" item item-2">Заключаем инвестиционный договор с передачей Вам соответствующих прав</div>
        </div>
        <div class="col-md-25 col-sm-60 no-padding">
            <div class=" item item-3">Наши специалисты открывают город или страну и осуществляют оперативное управление бизнесом</div>
        </div>
        <div class="col-md-28 col-sm-60 no-padding">
            <div class="item item-4">Прибыль от деятельности распределяется следующим образом: на дальнейшее развитие, выплата инвестору, выплата команде</div>
        </div>
    </div>
    <div class="read-text-middle">
        <div class="read-text-in">
            <div class="investment__list-text_1">Полная прозрачность</div>
            <div class="investment__list-text_2">Мы согласовываем инвестиционный план с точностью до 1 евро на весь период. Вы в онлайн режиме видите всю нашу работу и показатели.<br>В онлайн режиме Вам доступна полная финансовая картина по Вашему городу или стране.</div>
        </div>
        <div class="read-text-in">
            <div class="investment__list-text_1">Доступные города и страны</div>
            <div class="investment__list-text_2">Значительное количество городов и стран уже проданы либо по франчайзингу либо в рамках договора инвестирования.<br>Поэтому город или страну мы выберем вместе. </div>
        </div>
    </div>
    <div class="read-more-investment">
        <div class="wrapper clearfix">
            <div class="col-xs-120 no-padding">
                <h2>Оставьте заявку на участие в инвестиционной программе</h2>
                <p class="input-p">Срок рассмотрения заявок – до 3-х дней</p>
                <div id="application_franchise">
                    <div class="col-md-30 col-sm-60 padding">
                        <input type="text" name="name" placeholder="Ваше имя" v-model="user.name">
                    </div>
                    <div class="col-md-30 col-sm-60 padding">
                        <input type="text" name="email" placeholder="E-mail" required v-model="user.email"  title="Пример: example@mail.ru">
                    </div>
                    <div class="col-md-30 col-sm-60 padding">
                        <input v-model="user.phone" data-inputmask="'mask': ['999999999999', '+9(999) 999-9999', '+999 99-99-9999', '+999 99-999-999', '+99(999)999-99-99']" type="tel" name="phone" placeholder="Тел. номер" required>
                    </div>
                    <div class="col-md-30 col-xs-120 padding">
                        <button @click="sendOffer">Отправить</button>
                    </div>
                    <div class="clearfix"></div>
                    <div class="error alert alert-danger" v-if="errors.length > 0">
                        <p v-for="(error, index) in errors" :key="index">{{error}}</p>
                    </div>
                    <input type="hidden" name="ajax" value="true">
                </div>
            </div>
        </div>
    </div>
    <div class="footer">
        <div class="wrapper clearfix">
            <div class="col-md-20 no-padding">
                <div class="logo">
                    <router-link to="/"><img src="/static/img/general/logo-franchise-footer.png"></router-link>
                </div>
            </div>
            <div class="col-md-1">
                <div class="line"></div>
            </div>
            <div class="col-md-31">
                <div class="become-partner">
                    Стать эксклюзивным партнером:
                </div>
            </div>
            <div class="col-md-30">
                <div class="contacts">
                    <a href="mailto:s@v-avtoservice.com" class="email">s@v-avtoservice.com</a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'SaleInvestment',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      errors: []
    }
  },
  methods: {
    sendOffer () {
      this.errors = []
      if (!this.user.name) this.errors.push('Необходимо указать имя')
      if (!this.user.phone) this.errors.push('Необходимо указать телефон')
      if (!this.user.email) this.errors.push('Необходимо указать почту')
      if (this.errors.length === 0) {
        setTimeout(function () { alert('Ваша заявка отправлена, в ближайшее время мы с Вами свяжемся') }, 1)
        var formData = new FormData()
        formData.append('crm', '1')
        formData.append('pipe', '3')
        formData.append('lead[36]', this.city.name)
        formData.append('note', 'Заявка на инвест программу')
        formData.append('contact[name]', this.user.name)
        formData.append('contact[3]', this.user.phone)
        formData.append('contact[4]', this.user.email)
        axios.post('https://crm.v-avtoservice.com/api/import-lead',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )

        var formDatas = new FormData()
        formDatas.append('crm', '7')
        formDatas.append('pipe', '13')
        formDatas.append('lead[102]', 'В-Автосервис ' + this.city.name + '(' + this.city.lang + ')')
        formDatas.append('lead[103]', this.city.name)
        formDatas.append('note', 'Заявка на инвест программу')
        formDatas.append('contact[name]', this.user.name)
        formDatas.append('contact[100]', this.user.phone)
        formDatas.append('contact[101]', this.user.email)
        formDatas.append('contact[106]', this.city.name)
        formDatas.append('contact[107]', 'В-Автосервис ' + this.city.name + '(' + this.city.lang + ')')
        axios.post('https://franch.v-avtoservice.com/api/import-lead',
          formDatas,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SaleInvestment.vue